export const RESPONSE_SIGNATURES_KEY = 'response-signatures';
export const RESPONSE_TEMPLATES_KEY = 'response-templates';
export const RESPONSE_PLACE_KEY = 'response-place';
export const RESPONSE_PLACES_KEY = 'response-places';
export const RESPONSE_ORGANIZATION_KEY = 'response-organization';
export const RESPONSE_ORGANIZATIONS_KEY = 'response-organizations';
export const LIST_REVIEW_RESPONSE_TICKETS_KEY = 'list-review-response-tickets';
export const REVIEW_RESPONSE_TICKET_KEY = 'review-response-ticket';
